import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getProviderStripePaymentStatus = createAsyncThunk("provdier/check-stripe-acc-status", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/check-stripe-acc-status`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers stripe payment status");
  }
});

export const getProviderStripeBankAccount = createAsyncThunk("provider/get-stripe-bank-account", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/get-stripe-bank-account`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers stripe payment status");
  }
});

export const getProviderStripePayoutes = createAsyncThunk(
  "provider/get-stripe-payouts",
  async ({token, bankId}, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/get-stripe-payouts/${bankId}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    console.log("bank_id", bankId);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers stripe payment status");
  }
});

const providerPaymentSettingSlice = createSlice({
  name: "providerStripePaymentSetting",
    initialState: {
        providerStripePaymentSetting: null,
        providerStripeBankAcc: [],
        providerStripePayouts: [],
        },
            extraReducers: (builder) => {
              builder
                .addCase(getProviderStripePaymentStatus.pending, (state) => {
                    state.loading = true;
                })
                .addCase(getProviderStripePaymentStatus.fulfilled, (state, action) => {
                    state.providerStripePaymentSetting = action.payload;
                    state.loading = false;
                })
                .addCase(getProviderStripePaymentStatus.rejected, (state, action) => {
                    state.error = action.payload || "Failed to fetch providers payment"; 
                    state.loading = false;
                })
                .addCase(getProviderStripeBankAccount.pending, (state) => {
                  state.loading = true;
                })
                .addCase(getProviderStripeBankAccount.fulfilled, (state, action) => {
                    state.providerStripeBankAcc = action.payload.externalAccounts.data;
                    state.loading = false;
                })
                .addCase(getProviderStripeBankAccount.rejected, (state, action) => {
                    state.error = action.payload || "Failed to fetch providers payment"; 
                    state.loading = false;
                })
                .addCase(getProviderStripePayoutes.pending, (state) => {
                  state.loading = true;
                })
                .addCase(getProviderStripePayoutes.fulfilled, (state, action) => {
                    state.message = action.payload.message;
                    // state.providerStripePayouts = action.payload.payouts.data;
                    state.loading = false;
                })
                .addCase(getProviderStripePayoutes.rejected, (state, action) => {
                    state.error = action.payload || "Failed to fetch providers payment"; 
                    state.loading = false;
                })
                    },
});

export default providerPaymentSettingSlice.reducer;